import * as tslib_1 from "tslib";
import { memoize, parseFieldSpecs } from '@fullcalendar/core';
import { AbstractDayGridView, buildBasicDayTable } from '@fullcalendar/daygrid';
import { ResourceDayHeader, ResourceDayTable, DayResourceTable, flattenResources } from '@fullcalendar/resource-common';
import ResourceDayGrid from './ResourceDayGrid';
var ResourceDayGridView = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceDayGridView, _super);
    function ResourceDayGridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flattenResources = memoize(flattenResources);
        _this.buildResourceDayTable = memoize(buildResourceDayTable);
        return _this;
    }
    ResourceDayGridView.prototype._processOptions = function (options) {
        _super.prototype._processOptions.call(this, options);
        this.resourceOrderSpecs = parseFieldSpecs(options.resourceOrder);
    };
    ResourceDayGridView.prototype.render = function (props, context) {
        _super.prototype.render.call(this, props, context); // for flags for updateSize. also _renderSkeleton/_unrenderSkeleton
        var options = context.options, nextDayThreshold = context.nextDayThreshold;
        var resources = this.flattenResources(props.resourceStore, this.resourceOrderSpecs);
        var resourceDayTable = this.buildResourceDayTable(props.dateProfile, props.dateProfileGenerator, resources, options.datesAboveResources);
        if (this.header) {
            this.header.receiveProps({
                resources: resources,
                dates: resourceDayTable.dayTable.headerDates,
                dateProfile: props.dateProfile,
                datesRepDistinctDays: true,
                renderIntroHtml: this.renderHeadIntroHtml
            }, context);
        }
        this.resourceDayGrid.receiveProps({
            dateProfile: props.dateProfile,
            resourceDayTable: resourceDayTable,
            businessHours: props.businessHours,
            eventStore: props.eventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isRigid: this.hasRigidRows(),
            nextDayThreshold: nextDayThreshold
        }, context);
    };
    ResourceDayGridView.prototype._renderSkeleton = function (context) {
        _super.prototype._renderSkeleton.call(this, context);
        if (context.options.columnHeader) {
            this.header = new ResourceDayHeader(this.el.querySelector('.fc-head-container'));
        }
        this.resourceDayGrid = new ResourceDayGrid(this.dayGrid);
    };
    ResourceDayGridView.prototype._unrenderSkeleton = function () {
        _super.prototype._unrenderSkeleton.call(this);
        if (this.header) {
            this.header.destroy();
        }
        this.resourceDayGrid.destroy();
    };
    ResourceDayGridView.needsResourceData = true; // for ResourceViewProps
    return ResourceDayGridView;
}(AbstractDayGridView));
export default ResourceDayGridView;
function buildResourceDayTable(dateProfile, dateProfileGenerator, resources, datesAboveResources) {
    var dayTable = buildBasicDayTable(dateProfile, dateProfileGenerator);
    return datesAboveResources ?
        new DayResourceTable(dayTable, resources) :
        new ResourceDayTable(dayTable, resources);
}
